import { render, staticRenderFns } from "./treatment-enhancements.vue?vue&type=template&id=a20cd34c&"
import script from "./treatment-enhancements.vue?vue&type=script&lang=ts&"
export * from "./treatment-enhancements.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports